/**
 * Interfaz que define el estado del módulo de usuarios
 */
import Pagination from '@/modules/core/model/pagination'
import User from '@/modules/user/model/User'
import {Module} from 'vuex'
import {RootState} from '@/store/types'
import mutations from '@/modules/user/store/mutations'
import actions from '@/modules/user/store/actions'
import Session from '@/modules/user/model/Session';
import UserGroup from '@/modules/user/model/UserGroup';

/* export interface Task {
    // task: {[key: string]: () => Promise<any>}
    task: () => Promise<any>
} */

export interface UserState {
    /**
     * Paginación de usuarios actualmente mostrada al usuario
     */
    usersPagination: Pagination<User>

    /**
     * Paginaciones nombradas
     *
     * Las paginaciones nombradas permiten registrar multiples paginaciones de usuario
     * asociados a un identificador (nombre).
     *
     * Esto permite mantener la paginación principal sin modificar mientras
     * se almacenan multiples paginaciones de usuario.
     */
    namedUserPaginations: {[key: string]: Pagination<User>}

    /**
     * Usuario actualmente en edición por el usuario
     */
    currentUser: User,

    /**
     * Indica si la pantalla de información del usuario esta comprobado que el correo electrónico
     * introducido esta disponible
     */
    checkingEmailAvailability: boolean

    /**
     * Paginación de sesiones
     */
    sessionsPagination: Pagination<Session>,

    /**
     * Grupos de usuarios registrados en la aplicación
     */
    userGroups: UserGroup[],

    /**
     * Indica si la aplicación ha obtenido la lista de grupos de usuarios
     */
    userGroupsFetched: boolean,

    /**
     * Grupo de usuarios actualmente seleccionado por el usuario
     */
    userGroup: UserGroup,

    /**
     * Lista de usuarios seleccionados en las pantallas de administración
     * de grupos de usuarios.
     */
    selectedGroupUsers: User[],

    /**
     * Indica si se va a borrar un usuario de la plataforma, esto es cuando se borra un usuario
     * del panel y es un usuario enrutado (de Unigest.web) aparace tambien un check indicando si
     * tambien se quiere borrar de la plataforma.
     */
    checkingiDeleteFromBBDDUnigest: boolean,

    tasksBeforeDeleteUser: Map<string, () => Promise<any>>, // {[key: string]: Task},
    tasksBeforeDeleteUserGroup: Map<string, () => Promise<any>>,

    /**
     * Indica si debe de validar que el grupo seleccionado no sea padre o si o no realizar validación, es decir,
     * si esta variable es valor 0 no realiza validación, muestra todos los grupos, si el valor es 1 no admitir
     * mostrar en el componente UserGroupList los grupos que sean padre y si es valor 2 es motrar solo los grupos
     * padre, osea no mostrar los grupos hijos.
     */
    validateGroupYesNotBeParent: number
}

const module: Module<UserState, RootState> = {
    namespaced: true,
    mutations,
    actions,
    state: {
        usersPagination: { totalRecords: 0, totalPages: 0, items: [] },
        currentUser: new User(),
        checkingEmailAvailability: false,
        sessionsPagination: { totalRecords: 0, totalPages: 0, items: [] },
        userGroups: [],
        userGroupsFetched: false,
        userGroup: new UserGroup(),
        selectedGroupUsers: [],
        namedUserPaginations: {},
        checkingiDeleteFromBBDDUnigest: false,
        tasksBeforeDeleteUser: new Map<string, () => Promise<any>>(),
        tasksBeforeDeleteUserGroup: new Map<string, () => Promise<any>>(),
        validateGroupYesNotBeParent: 0,
    },
}

export default module
